import styled from "styled-components";
import { Link } from "react-router-dom";

export const ReservationContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: white;
  padding-bottom: 60px;
`;

export const ReservationHeader = styled.div`
  display: flex;
  z-index: 10;
  max-width: 480px;
  width: 100%;
  height: 60px;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  padding: 0 20px;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  border-bottom: 1px solid #E5E5E5;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const BackButton = styled.button`
  border: none;
  background: none;
  padding: 8px;
  cursor: pointer;
  color: #333;
  font-size: 20px;
  display: flex;
  align-items: center;
`;

export const ReservationTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #333;
`;

export const ReservationSearch = styled(Link)`
  text-decoration: none;
  color: #333;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
`;

export const CategoryContainer = styled.div`
  display: flex;
  height: calc(100vh - 120px);
  margin-top: 60px;
`;

export const LeftCategory = styled.div`
  width: 40%;
  background-color: #F8F8F8;
  overflow-y: auto;
  border-right: 1px solid #E5E5E5;
`;

export const RightCategory = styled.div`
  width: 60%;
  background-color: white;
  overflow-y: auto;
`;

export const CategoryItem = styled.div<{ active: boolean }>`
  padding: 20px 20px;
  font-size: 15px;
  color: ${props => props.active ? '#1FBC70' : '#666'};
  background-color: ${props => props.active ? 'white' : 'transparent'};
  font-weight: ${props => props.active ? '600' : '400'};
  cursor: pointer;
  border-left: ${props => props.active ? '3px solid #1FBC70' : '3px solid transparent'};
  transition: all 0.2s;

  &:hover {
    background-color: white;
  }
`;

export const FacilityItem = styled.div`
  padding: 20px 20px;
  font-size: 15px;
  color: #333;
  cursor: pointer;
  border-bottom: 1px solid #F5F5F5;
  transition: all 0.2s;

  &:hover {
    background-color: #F9F9F9;
  }

  &:active {
    background-color: #F0F0F0;
  }
`;

export const EmptyState = styled.div`
  padding: 60px 20px;
  text-align: center;
  color: #999;
  font-size: 14px;
`;
